<template>
    <div v-if="mostrar" style="overflow: auto" class="modal-mask" @click="$emit('fechar')">
        <div style="max-height: 80%; max-width: 900px ;width: 70%; padding: 3rem;" class="modal-container" @click.stop>
            <div>
                <div style="display: flex; justify-content: space-between">
                    <h3 class="titulo">Cadastrar Programa </h3>
                    <button type="button" class="btn-close" aria-label="Close" @click="$emit('fechar')"></button>
                </div>
                <hr>
                <br>
                <div style="display: flex;">
                    <div class="form-group" style="width: 30rem;">
                        <label for="nome">Nome do Programa</label>
                        <input id="nome" v-model="localNovo.nome" type="text" class="form-control">
                    </div>
                    <div class="form-group" style="width: 20rem; margin-left: 2rem;">
                        <label for="data">Data de Início</label>
                        <input id="data" v-model="localNovo.dtInicio" type="date" class="form-control">
                    </div>
                </div>
                <div style="display: flex;">
                    <div class="form-group" style="width: 30rem;">
                        <label for="gerente">Gerente Responsável</label>
                        <select id="gerente" v-model="localNovo.gerente_id" class="form-select">
                            <option v-for="item in gerente" :key="item.id" :value="item.id">
                                {{ item.nomeCompleto }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" style="width: 20rem; margin-left: 2rem;">
                        <label for="dataFim">Data de Término</label>
                        <input id="dataFim" v-model="localNovo.dtFim" type="date" class="form-control">
                    </div>
                </div>
                <div style="display: flex; justify-content: right;">
                    <button @click="onSalvar"
                        style="height: 2.5rem; background-color: #F89E31; border: none;"
                        class="btn btn-primary float-right mr-2">Salvar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalNovoPrograma",
    props: {
        mostrar: { type: Boolean, default: false },
        gerente: { type: Array, default: () => [] },
    },
    emits: ["fechar", "salvar"],
    data() {
        const hoje = new Date();
        const dtInicio = [hoje.getFullYear(), String(hoje.getMonth() + 1).padStart(2, "0"), String(hoje.getDate()).padStart(2, "0")].join("-");
        return {
            localNovo: {
                nome: "",
                dtInicio,
                gerente_id: "",
                dtFim: "",
            },
        };
    },
    watch: {
        mostrar(visivel) {
            if (visivel) {
                const hoje = new Date();
                this.localNovo = {
                    nome: "",
                    dtInicio: [hoje.getFullYear(), String(hoje.getMonth() + 1).padStart(2, "0"), String(hoje.getDate()).padStart(2, "0")].join("-"),
                    gerente_id: "",
                    dtFim: "",
                };
            }
        },
    },
    methods: {
        onSalvar() {
            this.$emit("salvar", { ...this.localNovo });
        },
    },
};
</script>
